(function () {
'use strict';

angular.module('hyresgastApp').filter('hyJoinBy', function() {
  return function(input, delimiter) {
    return (input || []).join(delimiter || ', ');
  };
});

})();